import SectorAPI from 'dashboard/api/sectors';
import { createStore } from 'dashboard/store/storeFactory';

export const useSectorsStore = createStore({
  name: 'sectors',
  type: 'pinia',
  API: SectorAPI,
});
